import { I18nComponente } from "@/types/gerais"

export const Logini18n: I18nComponente = {
  "pt-BR": {
    naoFoiPossivelEntrar: "Não foi possível entrar",
    oUsuarioOuSenhaEstaoIncorretos:
      "O usuário ou senha estão incorretos. Confira as informações e tente novamente",
    camposInvalidos: "campos inválidos",
    completeOsCamposCorretamente: "Complete os campos corretamente",
    erroAoAutenticarComKeycloak:
      "Não foi possível concluir a autenticação corporativa. Tente novamente.",
    usuarioSemAcessoAoTimesheet:
      "Sua identidade foi autenticada, mas não possui acesso ativo ao Timesheet.",
  },
  "es-CO": {
    naoFoiPossivelEntrar: "No se pudo iniciar sesión",
    oUsuarioOuSenhaEstaoIncorretos:
      "El nombre de usuario o la contraseña son incorrectos. Verifique la información e intente nuevamente",
    camposInvalidos: "campos inválidos",
    completeOsCamposCorretamente: "Complete los campos correctamente",
    erroAoAutenticarComKeycloak:
      "No fue posible completar la autenticación corporativa. Inténtelo de nuevo.",
    usuarioSemAcessoAoTimesheet:
      "Su identidad fue autenticada, pero no tiene acceso activo a Timesheet.",
  },
}
